function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  fill: "currentColor",
  height: "1em",
  width: "1em",
  viewBox: "64 64 896 896",
  transform: "scale(1.5)"
}, props), React.createElement("rect", {
  x: "5.75",
  y: "4.5",
  width: "22.5",
  height: "15.75",
  rx: "2.25",
  transform: "matrix(25 0 0 25 75 175)",
  fillRule: "evenodd"
})));